import { useEffect, useRef, useState, useMemo } from "react";
import ButtonBot from "shared/components/ButtonBot";
import AppInput from "shared/components/AppInput";
import plusIcon from "assets/icons/plusIcon.svg";
import cameraIcon from "assets/icons/cameraIcon.svg";
import AppCheckBox from "shared/components/AppCheckBox";
import { useLocation, useNavigate } from "react-router-dom";
import Tesseract, { createWorker } from 'tesseract.js';
import { useDispatch, useSelector } from "react-redux";
import { setShowHeader } from "shared/store/headerSlice";
import captureIcon from "assets/icons/captureIcon.svg";
import captureClose from "assets/icons/captureClose.svg";
import { set, useForm } from "react-hook-form";
import { replaceImageLink } from "utils/common";
import { setCarCheckIn } from "features/parking/presentation/store/parkingSlice";
import { recognition, saveCarImage, updateSpaceUse, modifyCarInfo } from "features/parking/usecases/CarInOutUsecases";
import { setAppLoading } from "shared/store/headerSlice";
import InputMask from "react-input-mask";
import Popup from "shared/components/Popup";
import { datetimeFormat, getCompressedDataUrl, getFormattedTime } from "../../../utils/common";
import { DateTime } from "luxon";
import imageNotFound from "assets/images/imageNotFound.png";
import { getParkingOperateTime } from "../usecases/CarInOutUsecases";
import { setUser, setDayType, setServerTime } from "../../auth/presentation/store/authSlice";
import { getServerTime } from "features/auth/usecases/AuthUsecases";
import Skeleton from 'react-loading-skeleton';
import AppInfiniteScroll from "../../../shared/components/AppInfiniteScroll";
import ImageViewPopup from "../../../shared/components/ImageViewPopup";
import { ThreeDots } from 'react-loader-spinner';

const ParkingCheck = () => {
    // Utility to generate hour and minute options
    // const generateHours = () => Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
    // const generateMinutes = () => Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

    const [generateHours, setGenerateHours] = useState([]);
    const [generateMinutes, setGenerateMinutes] = useState([]);
    const { register, handleSubmit, setValue, watch, formState: { errors }, clearErrors, trigger } = useForm();
    const navigation = useNavigate();
    const location = useLocation();
    const { selectedSpotState } = location.state || {};

    const dispatch = useDispatch();
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const animationFrameIdRef = useRef(null);
    const streamRef = useRef(null);
    const ocrLoadingRef = useRef(false);
    const isSquareFrameRef = useRef(false);
    const flagRef = useRef(0);
    const { selectedSpots, selectedSpot, parkingName, parkingSpots } = useSelector((state) => state.parking);
    const { user, serverTime, dayType } = useSelector((state) => state.auth);
    const [currentText, setCurrentText] = useState('');
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isOpenCamera, setIsOpenCamera] = useState(false);
    const [checkParkingTime, setCheckParkingTime] = useState(false);
    const [checkParkingTimeEntry, setCheckParkingTimeEntry] = useState(false);

    const [worker, setWorker] = useState(null);
    const [showPopupError, setShowPopupError] = useState(false);
    const [showPopupNoImage, setShowPopupNoImage] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);
    const carIamge = selectedSpot?.inImageLink ? replaceImageLink(selectedSpot?.inImageLink) : imageNotFound;
    const watchCarNum = watch("carNum");
    const watchInHour = watch("inHour");
    const watchInMinute = watch("inMinute");
    const [activeTab, setActiveTab] = useState('T1');
    const [showPopupParkingOperateTime, setShowPopupParkingOperateTime] = useState(false);
    const [isSquareFrame, setIsSquareFrame] = useState(false);
    const [ocrLoading, setOcrLoading] = useState(false);

    const checkParkingOperateTime = async () => {
        // console.log("checkParkingOperateTime", watchInHour, watchInMinute, dayType);
        const response = await getParkingOperateTime({
            parkingId: user.parkingId,
        });
        let weekdayHours = response?.weekdayOperatingHours;

        if (dayType == 'WEEKEND' && response?.weekendOperatingHours) {
            weekdayHours = response?.weekendOperatingHours;
        } else if (dayType == 'HOLIDAY' && response?.holidayOperatingHours) {
            weekdayHours = response?.holidayOperatingHours;
        }

        if (!weekdayHours) return;

        dispatch(setUser({
            ...user,
            parking: {
                ...user.parking,
                weekdayOperatingHours: response?.weekdayOperatingHours,
                weekendOperatingHours: response?.weekendOperatingHours,
                holidayOperatingHours: response?.holidayOperatingHours,
            }
        }))

        const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
        const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
        const [workingEndHour, workingEndMinute] = endStr.split(":");


        if (watchInHour < workingBeginHour || (watchInHour == workingBeginHour && watchInMinute < workingBeginMinute)) {
            const hours = generateHoursChange(workingBeginHour, workingEndHour);
            setGenerateHours(hours);

            setValue("inMinute", workingBeginMinute);
            setValue("inHour", workingBeginHour);

            let result = [];

            if (watchInHour == workingBeginHour && watchInMinute < workingBeginMinute) {

                result = Array.from({ length: 60 - parseInt(workingBeginMinute) }, (_, i) =>
                    (i + parseInt(workingBeginMinute)).toString().padStart(2, "0")
                );
            }

            setGenerateMinutes(result);

            return false;
        } else if (watchInHour > workingEndHour || watchInHour == workingEndHour && watchInMinute > workingEndMinute) {
            const hours = generateHoursChange(workingBeginHour, workingEndHour);
            setGenerateHours(hours);

            setValue("inMinute", workingEndMinute);
            setValue("inHour", workingEndHour);

            let result = [];


            result = Array.from({ length: parseInt(workingEndMinute) }, (_, i) =>
                i.toString().padStart(2, "0")
            );

            setGenerateMinutes(result);

            return false;
        } else {
            return true;
        }

    }

    const generateTimeOptions = (user, setGenerateHours, setGenerateMinutes) => {
        let weekdayHours = user?.parking?.weekdayOperatingHours;

        if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
            weekdayHours = user?.parking?.weekendOperatingHours;
        } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
            weekdayHours = user?.parking?.holidayOperatingHours;
        }

        if (!weekdayHours) return;

        const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
        const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
        const [workingEndHour, workingEndMinute] = endStr.split(":");


        const result = generateHoursChange(workingBeginHour, workingEndHour);
        setGenerateHours(result);

        let minute_data = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
        if (watchInHour == workingBeginHour) {
            minute_data = Array.from({ length: 60 - parseInt(workingBeginMinute) }, (_, i) =>
                (parseInt(workingBeginMinute) + i).toString().padStart(2, "0")
            );
        } else if (watchInHour === workingEndHour) {
            minute_data = Array.from({ length: parseInt(workingEndMinute) + 1 }, (_, i) =>
                i.toString().padStart(2, "0")
            );
            if (watchInMinute > workingEndMinute) {
                setValue("inMinute", workingEndMinute);
            }
        }
        // console.log("minute_data", minute_data);
        setGenerateMinutes(minute_data);
    }

    const generateHoursChange = (start, end) => {
        const from = parseInt(start);
        const to = parseInt(end);
        return Array.from({ length: to - from + 1 }, (_, i) =>
            (from + i).toString().padStart(2, '0')
        );
    };

    const initWorker = async () => {
        const newWorker = await createWorker('kor');
        await newWorker.setParameters({
            tessedit_pageseg_mode: '9',
            tessedit_char_whitelist: '0123456789가나다라마바사아자허호배하히고구두영주거너더러머버서어저노도로모보소오조누루무부수우영',
        });
        setWorker(newWorker);
    };

    // Function to get server time and initialize the worker
    const checkTimePage = async () => {
        await new Promise(async (resolve, reject) => {
            try {
                const getServerTimeApi = await getServerTime();
                const serverTime = DateTime.fromISO(
                    getServerTimeApi?.ISO || DateTime.now().setZone('Asia/Seoul').toISO(),
                    { setZone: true }
                );

                dispatch(setServerTime(serverTime.isValid ? serverTime : DateTime.now().setZone('Asia/Seoul')));
                dispatch(setDayType(getServerTimeApi?.dayType || 'WEEKDAY'));

                setTimeout(() => {
                    setCheckParkingTimeEntry(true);
                }, 500);

                resolve();

            } catch (error) {
                console.error('Error checking time:', error);
                reject(error);
            }
        })
    };

    const updateTime = async () => {
        const currentTime = getFormattedTime(serverTime, "yyyy-MM-dd HH:mm");
        const hour = getFormattedTime(serverTime, "HH");
        const minute = getFormattedTime(serverTime, "mm");

        let weekdayHours = user?.parking?.weekdayOperatingHours;

        if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
            weekdayHours = user?.parking?.weekendOperatingHours;
        } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
            weekdayHours = user?.parking?.holidayOperatingHours;
        }

        if (!weekdayHours) return;

        const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
        const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
        const [workingEndHour, workingEndMinute] = endStr.split(":");


        if (hour < workingBeginHour || hour > workingEndHour || (hour == workingBeginHour && minute < workingBeginMinute) || (hour == workingEndHour && minute > workingEndMinute)) {

            setValue("inDate", currentTime);
            setValue("inHour", workingBeginHour);
            setValue("inMinute", workingBeginMinute);

        } else if (!checkParkingTime && !selectedSpot) {

            setValue("inDate", currentTime);
            setValue("inHour", hour);
            setValue("inMinute", minute);

        } else if (checkParkingTime && !selectedSpot) {
            setValue("inDate", currentTime);
            setValue("inHour", workingBeginHour);
            setValue("inMinute", workingBeginMinute);
        }


    };


    const onCheckbox = (e) => {

        const checked = e.target.checked;

        setCheckParkingTime(checked);

    };

    useEffect(() => {

        updateTime();

    }, [setValue, checkParkingTime, checkParkingTimeEntry]);

    // useEffect(() => {

    //     console.log("watchInHour", watchInHour);
    //     console.log("watchInMinute", watchInMinute);

    // }, [watchInHour, watchInMinute]);

    useEffect(() => {
        if (watchInHour) {
            let weekdayHours = user?.parking?.weekdayOperatingHours;

            if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
                weekdayHours = user?.parking?.weekendOperatingHours;
            } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
                weekdayHours = user?.parking?.holidayOperatingHours;
            }

            if (!weekdayHours) return;

            const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
            const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
            const [workingEndHour, workingEndMinute] = endStr.split(":");

            let result = [];

            if (watchInHour === workingEndHour) {
                result = Array.from({ length: parseInt(workingEndMinute) + 1 }, (_, i) =>
                    i.toString().padStart(2, "0")
                );
                if (watchInMinute > workingEndMinute) {
                    setValue("inMinute", workingEndMinute);
                }
            } else {
                result = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0"));
            }
            // console.log("result", result);
            setGenerateMinutes(result);
        }
    }, [watchInHour, setValue]);

    const onEnterPage = async () => {
        await checkParkingOperateTime();
        await checkTimePage();
        await initWorker();
    }

    const refreshFunction = () => {
        setCheckParkingTimeEntry(false);
        setImage(null);
        setValue("carNum", "");
        setActiveTab("T1");
        setCheckParkingTime(false);
        onEnterPage();
    }

    useEffect(() => {

        generateTimeOptions(user, setGenerateHours, setGenerateMinutes);

    }, [user]);

    // Starting worker tesseract once
    useEffect(() => {
        onEnterPage();

        return () => {
            worker && worker.terminate();
        };
    }, []);


    useEffect(() => {
        if (selectedSpot) {
            setValue("carNum", selectedSpot?.carNum.replace(/[^\p{L}\p{N}]/gu, '') || '');
            setValue("inDate", datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm") || '');
            const formattedTime = datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm") || '';
            const [_, timePart] = formattedTime.split(" ");

            if (timePart) {
                const [hour, minute] = timePart.split(":");
                setValue("inHour", hour);
                setValue("inMinute", minute);
            }
        }

    }, [selectedSpot, setValue]);

    useEffect(() => {
        if (watchCarNum && /\s/.test(watchCarNum)) {
            setValue("carNum", watchCarNum.replace(/\s/g, ""));
        }
    }, [watchCarNum, setValue]);

    // Combined image processing function
    const processImage = (canvas) => {
        const ctx = canvas.getContext('2d');
        let imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        let data = imageData.data;

        // Switch to Grayscale and increase the contrast intensity
        const contrastFactor = 1.5;
        for (let i = 0; i < data.length; i += 4) {
            const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
            const value = Math.min(255, Math.max(0, (avg - 128) * contrastFactor + 128));
            data[i] = data[i + 1] = data[i + 2] = value > 128 ? 255 : 0;
        }

        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };

    const startCamera = async () => {
        console.log(animationFrameIdRef.current)
        dispatch(setShowHeader(false));
        try {
            streamRef.current = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: 'environment', height: { ideal: 720 }, width: { ideal: 1280 } },
            });
            if (videoRef.current) {
                videoRef.current.srcObject = streamRef.current;
                videoRef.current.play();
            }

            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');
            let lastProcessed = 0;
            const processInterval = 2000;

            const recognizeTextLive = async () => {
                if (!videoRef.current || videoRef.current.readyState < 2) {
                    animationFrameIdRef.current = requestAnimationFrame(recognizeTextLive);
                    return;
                }
                const now = Date.now();
                if (now - lastProcessed < processInterval) {
                    animationFrameIdRef.current = requestAnimationFrame(recognizeTextLive);
                    return;
                }
                lastProcessed = now;

                canvas.width = videoRef.current.clientWidth;
                canvas.height = videoRef.current.clientHeight;
                context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
                const imageData = canvas.toDataURL('image/png');

                if (imageData && worker) {
                    const img = new Image();
                    img.src = imageData;
                    img.onload = async () => {
                        const cropWidth = !isSquareFrameRef.current ? 200 : 240;
                        const cropHeight = !isSquareFrameRef.current ? 60 : 140;
                        const croppedCanvas = croppedImage(cropWidth, cropHeight, img);
                        // processImage(croppedCanvas);
                        const croppedImageUrl = croppedCanvas.toDataURL('image/jpeg', 1.0);

                        try {
                            console.log(ocrLoadingRef.current);
                            if (!ocrLoadingRef.current) {

                                const text = await recognizeTextWithCustomApi(croppedImageUrl);
                                // const text = await recognizeText(croppedImageUrl);
                                // setValue("carNum", text);
                                // const { data: { text } } = await worker.recognize(croppedImageUrl);
                                // const filteredText = filterLicensePlate(text);
                                setCurrentText(text || '');
                            }
                        } catch (err) {
                            setCurrentText('Definition of failure');
                        }
                    };
                }
                animationFrameIdRef.current = requestAnimationFrame(recognizeTextLive);
            };
            setTimeout(() => {
                recognizeTextLive();
            }, 1000);

        } catch (err) {
            console.log(`Camera opening error: ${err.message}`);
        }
    };

    const filterLicensePlate = (rawText) => {
        if (!rawText) return null;
        const normalizedText = rawText.replace(/[^\p{L}\p{N}]/gu, '').trim();
        // const licensePlatePattern = /(\d{2,3})([가-힣A-Z])(\d{4})/;
        const licensePlatePattern = /^[\d가-힣]{6,9}$/;
        const match = normalizedText.match(licensePlatePattern);
        return normalizedText;
    };

    const recognizeText = async (imageUrl) => {
        if (!imageUrl || !worker) {
            return;
        }
        setLoading(true);
        try {
            const { data: { text } } = await worker.recognize(imageUrl);
            const filteredText = filterLicensePlate(text);
            setValue("carNum", filteredText?.replace(/[^\p{L}\p{N}]/gu, '') || '');
            return filteredText;
        } catch (error) {
            setValue("carNum", '');
            return '';
        } finally {
            setLoading(false);
        }
    };

    const croppedImage = (cropWidth, cropHeight, img) => {
        const cropX = Math.max(0, Math.min((img.width - cropWidth) / 2, img.width - cropWidth));
        const cropY = Math.max(0, Math.min((img.height - cropHeight) * 0.5, img.height - cropHeight));
        const canvas = document.createElement('canvas');
        canvas.width = cropWidth;
        canvas.height = cropHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
        return canvas;
    };

    useEffect(() => {
        isOpenCamera && startCamera();
        if (!isOpenCamera) {
            if (animationFrameIdRef.current) {
                cancelAnimationFrame(animationFrameIdRef.current);
                animationFrameIdRef.current = null;
            }
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                streamRef.current = null;
            }

            ocrLoadingRef.current = false;
            setCurrentText('');
        }
        return () => {
            if (videoRef.current && videoRef.current.srcObject) {
                videoRef.current.srcObject.getTracks().forEach(track => track.stop());
            }
        };
    }, [isOpenCamera]);

    const recognizeTextWithGoogleVision = async (imageUrl) => {
        const url = `https://vision.googleapis.com/v1/images:annotate?key=${process.env.REACT_APP_GOOGLE_API}`;

        const requestBody = {
            requests: [
                {
                    image: { content: imageUrl.split(',')[1] }, // Base64 series from images
                    features: [{ type: 'TEXT_DETECTION' }],
                    imageContext: {
                        languageHints: ['ko'], // Indications for Korean identification priority
                    },
                }
            ]
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(requestBody),
                headers: { 'Content-Type': 'application/json' }
            });

            const data = await response.json();
            // console.log("response", data);
            const text = data.responses?.[0].textAnnotations?.[0].description;
            const filteredText = filterLicensePlate(text); // Filter function of your license plate
            return filteredText || '';
        } catch (error) {
            console.error('Error with Google Vision API:', error);
            return await recognizeText(imageUrl); // Fallback to Tesseract if Google Vision fails
        }
    };

    const recognizeTextWithCustomApi = async (imageUrl) => {

        const url = process.env.REACT_APP_OCR_API;

        try {
            setOcrLoading(true)
            ocrLoadingRef.current = true;
            const response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    image: imageUrl
                }),
                headers: { 'Content-Type': 'application/json' }
            });

            const data = await response.json();
            console.log("response", data);
            const text = data?.text;
            const filteredText = filterLicensePlate(text); // Filter function of your license plate
            setOcrLoading(false)
            ocrLoadingRef.current = false;
            return filteredText || '';


        } catch (error) {
            console.log('Error with Google Vision API:', error);
            setOcrLoading(false)
            const subText = await recognizeText(imageUrl); // Fallback to Tesseract if Google Vision fails
            ocrLoadingRef.current = false;
            return subText;
           

        }
    }

    const captureImage = () => {
        if ('vibrate' in navigator) navigator.vibrate(300);
        if (videoRef.current && canvasRef.current) {
            const canvas = canvasRef.current;
            canvas.width = videoRef.current.clientWidth;
            canvas.height = videoRef.current.clientHeight;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
            const imageData = canvas.toDataURL('image/png');

            setIsOpenCamera(false);
            dispatch(setShowHeader(true));

            if (imageData) {
                const img = new Image();
                img.src = imageData;
                img.onload = async () => {
                    const cropWidthSmall = !isSquareFrame ? 200 : 240;
                    const cropHeightSmall = !isSquareFrame ? 60 : 140;
                    const croppedCanvasSmall = croppedImage(cropWidthSmall, cropHeightSmall, img);
                    // processImage(croppedCanvasSmall);
                    const croppedImageUrl = croppedCanvasSmall.toDataURL('image/jpeg', 1.0);
                    // const text = await recognizeText(croppedImageUrl);
                    const croppedImageUrlSave = await getCompressedDataUrl(canvas, 30);
                    // console.log("croppedImageUrlSave", croppedImageUrlSave);
                    setImage(croppedImageUrlSave);
                    const text = await recognizeTextWithCustomApi(croppedImageUrl);
                    setValue("carNum", text);
                    // const cropWidthLarge = 340;
                    // const cropHeightLarge = 240;
                    // const croppedCanvasLarge = croppedImage(cropWidthLarge, cropHeightLarge, img);
                    // const croppedImageUrlSave = croppedCanvasLarge.toDataURL('image/jpeg', 0.5);

                };
            }
        }
    };

    const onCloseCamera = () => {
        setIsOpenCamera(false);
        dispatch(setShowHeader(true));
        if (videoRef.current && videoRef.current.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        }
    };

    const onSubmit = async (data) => {


        try {
            if (!image) {
                setShowPopupNoImage(true);
                return;
            }

            setLoading(true);
            dispatch(setAppLoading(true));

            const isValidTime = await checkParkingOperateTime();
            if (!isValidTime) {
                setShowPopupParkingOperateTime(true);
                setLoading(false);
                dispatch(setAppLoading(false));
                return;
            }

            let inDate = serverTime?.set({
                hour: data.inHour,
                minute: data.inMinute,
                second: 0
            });

            if (selectedSpot?.carNum) {
                const result = await modifyCarInfo({
                    parkingId: user.parkingId,
                    carNumber: selectedSpot?.carNum,
                    changeCarNumber: data.carNum,
                    angle: "MAIN",
                    inTime: inDate,
                    userId: user.userId,
                    imagePath: image,
                });
                result.success == true && result.status == 200 && image && await saveCarImage({
                    ...data,
                    entryId: result.entryId,
                    carNumber: data?.carNum,
                    imagePath: image,
                    parkingId: user.parkingId,
                    facilityKind: "LPR_IN",
                    angle: "MAIN",
                    recognitionId: "11",
                });
                if (result.success == true && result.status == 200) {
                    dispatch(setCarCheckIn({ ...data, entryId: result.entryId, carNumber: data?.carNum, dateTime: inDate }));
                    navigation("/parking_check_result", { replace: true });
                } else {
                    throw new Error("입차 실패! 다시 시도해주세요.");
                }
            } else {
                const payload = {
                    parkingId: user.parkingId,
                    facilityId: selectedSpotState?.spaceNumber?.toString().padStart(5, "0") || "00001",
                    facilityKind: "LPR_IN",
                    angle: "MAIN",
                    recognitionId: "11",
                    carNumber: data.carNum.replace(/[^\p{L}\p{N}]/gu, ''),
                    dateTime: inDate,
                    payStationId: "MOBILE",
                    userId: user.userId
                };
                const result = await recognition(payload);
                await saveCarImage({
                    ...payload,
                    imagePath: image,
                });
                await updateSpaceUse({
                    ...payload,
                    entryId: result.entryId,
                    spaceNumbers: selectedSpots,
                    areaName: selectedSpotState?.areaName,
                    areaTypeName: selectedSpotState?.areaTypeName,
                });
                if (result) {
                    dispatch(setCarCheckIn({ ...payload, entryId: result.entryId }));
                    navigation("/parking_check_result", {
                        replace: true,
                        state: {
                            selectedSpots,
                            selectedSpotState: result,
                        },
                    });
                }
            }
        } catch (error) {
            console.log(error);
            setShowPopupError(true);
        } finally {
            setLoading(false);
            dispatch(setAppLoading(false));
        }
    };

    const onError = (errors) => { };

    const handleImageError = (e) => {
        console.error("Image failed to load:", e.target.src);
        e.target.onerror = null; // Prevent looping
        e.target.style.height = '100%';
        e.target.style.objectFit = 'contain'; // Placeholder image
        e.target.src = imageNotFound; // Placeholder image
    }

    const containerRef = useRef(null);

    useEffect(() => {
        if (carIamge || image) {
            if (containerRef.current) {
                const img = containerRef.current.querySelector('img');
                // Handle image loading errors
                img.onerror = () => {
                    clearInterval(interval);
                };
                // Check immediately if the image has loaded
                if (img.naturalWidth > 0 && img.naturalHeight > 0) {
                    const scrollPosition = (img.naturalHeight - 185) * 0.5 - 30;
                    containerRef.current.scrollTo({
                        top: scrollPosition,
                    });
                    // console.log(1);
                    return;
                }
                // Periodically check if image is not loaded
                const interval = setInterval(() => {
                    if (img.naturalWidth > 0 && img.naturalHeight > 0) {
                        // Calculate 75% of the scroll height
                        const scrollPosition = (img.naturalHeight - 185) * 0.5 - 30;
                        containerRef.current.scrollTo({
                            top: scrollPosition,
                        });
                        // console.log(img.naturalHeight);
                        // console.log(2);
                        clearInterval(interval);
                    }
                }, 100);
                // Clean up when component unmounts
                return () => clearInterval(interval);
            }
        }
    }, [carIamge, image]);

    useEffect(() => {
        if (activeTab !== 'T1') {
            clearErrors('carNum'); // Clear errors for carNum when activeTab is not 'T1'
        }
    }, [activeTab, clearErrors]);


    const onSquareFrame = (e) => {
        const checked = e.target.checked;
        setIsSquareFrame(checked);
        isSquareFrameRef.current = checked;
    };

    return (
        <>
            {isOpenCamera && (

                <div className={`htVideoContainer ${!isSquareFrame ? '' : 'nl-square-frame'}`} style={{ overflowY: 'auto' }}>
                    <img src={captureClose} alt="" className="htCaptureClose" onClick={onCloseCamera} />
                    <video ref={videoRef} autoPlay playsInline className="video" />
                    <div className="htBackground">
                        {/* <div className="htChild" /> */}
                        <div className="nl-square">
                            <label className="htCheckboxContainer">
                                <AppCheckBox onChange={onSquareFrame} checked={isSquareFrame} />
                                <span style={{ color: '#fff' }}>구형번호판</span>
                            </label>
                        </div>
                        <div className="htChild2">
                            <div className="htChild" />
                            <div className="htCornerBorder">

                                <div className="htRecognize">
                                    {
                                        ocrLoading && <ThreeDots
                                            height="15"
                                            width="40"
                                            color="#4fa94d"
                                            ariaLabel="loading"
                                        />
                                    }
                                    {currentText || <div style={{ height: 15 }}></div>}
                                </div>
                                <div className="htCornerBorderSub" />
                                <div className="htCameraControls">
                                    <button type="button" className="htCaptureButton" onClick={captureImage}>
                                        <img src={captureIcon} alt="" />
                                    </button>
                                </div>
                            </div>
                            <div className="htChild" />
                        </div>
                        {/* <div className="htChild" /> */}
                    </div>
                    <div className="htScanFrame" />
                    <canvas ref={canvasRef} style={{ display: 'none' }} />
                </div>
            )}

            {!checkParkingTimeEntry ?
                <ParkingCheckSkeleton /> :
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <AppInfiniteScroll
                        data={[]}
                        hasMore={false}
                        refreshFunction={refreshFunction}
                        pullDownToRefresh={false}
                    >
                        <div className="htContainer has-fixed-buttons">
                            <div className="sub-header justify-center">
                                <div className="sub-header-text w-full">
                                    <span className="htColorGray2">주차장명 : </span>
                                    <span className="htBold">{`${user?.parking?.parkingName} (${user?.parkingId})`}</span>
                                </div>
                            </div>
                            <div style={{ paddingTop: '20px', width: '100%' }}>
                                {selectedSpots.length >= 2 && (
                                    <div className="nl-text-note-red nl-right px-20">주차면 2개가 선택되었습니다</div>
                                )}
                                <div className="htContent  pb-80 nl-max">
                                    {selectedSpot?.inImageLink && !image ? (
                                        <div className="htCarImage" onClick={() => setIsPopupOpen(true)}>
                                            <div ref={containerRef} className="nl-image-license-plate">
                                                <img
                                                    src={carIamge}
                                                    alt="Car"
                                                    onError={handleImageError}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            {image ? (
                                                <div className="htCarImage" onClick={() => setIsPopupOpen(true)}>
                                                    <div ref={containerRef} className="nl-image-license-plate">
                                                        <img src={image}
                                                            alt="Uploaded"
                                                            onError={handleImageError} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <label className="htCarImage"
                                                    onClick={() => setIsOpenCamera(true)}
                                                    style={image ? null : { border: '2px dashed #D2D2D2', backgroundColor: "#F8F8F8", overflow: 'hidden' }}
                                                >
                                                    <div className="nl-text-add">
                                                        <span className="htAddIcon"><img src={plusIcon} alt="Add" /></span>
                                                        <p className="htCarImageText">화면을 선택하여 차량번호 촬영하기</p>
                                                    </div>
                                                </label>
                                            )}
                                        </>

                                    )}
                                    <div className="nl-row j-end">
                                        <button
                                            className="htCameraButton"
                                            type="button"
                                            onClick={() => setIsOpenCamera(true)}
                                        >
                                            <span className="htCameraIcon"><img src={cameraIcon} alt="Camera" /></span>
                                            <span className="htRetakeText">재촬영</span>
                                        </button>
                                    </div>
                                    <div className="nh-sub" style={{ marginBottom: '20px' }}>
                                        <div className="nl-row nh-tab">
                                            <div className={`col-6 nh-menu ${activeTab === 'T1' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('T1')}>
                                                차량번호
                                            </div>
                                            <div className={`col-6 nh-menu ${activeTab === 'T2' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('T2')}>
                                                임시번호
                                            </div>
                                        </div>
                                    </div>
                                    <AppInput
                                        maxLength={activeTab === 'T1' ? 9 : 20}
                                        className="htBold"
                                        label={activeTab === 'T1' ? '차량번호' : '임시번호'}
                                        placeholder={activeTab === 'T1' ? "차량번호 입력 (예: 00가0000)" : "차량번호 입력"}
                                        register={register("carNum", {
                                            required: { value: true, message: '차량번호를 입력하세요.' },
                                            pattern: activeTab === 'T1' ? {
                                                // value: /^\d{2,3}[가-힣]\s?\d{4}$/,
                                                value: /^[\d가-힣]{6,9}$/,
                                                message: '번호판이 유효하지 않습니다.'
                                            } : undefined,
                                            validate: (value) => {
                                                const existed = parkingSpots?.find(s => s?.carNum?.replace(/[^\p{L}\p{N}]/gu, '') === value?.replace(/[^\p{L}\p{N}]/gu, '') && s.entryId !== selectedSpot?.entryId);
                                                return existed ? "해당 차량은 이미 주차장에 있습니다." : true;
                                            }
                                        })}
                                        error={errors.carNum}
                                    />
                                    {/* <InputMask
                            mask="9999-99-99 99:99"
                            {...register('inDate', {
                                required: { value: true, message: '입차일시를 입력하세요.' },
                                pattern: { value: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/, message: '입차일시가 유효하지 않습니다.' },
                                validate: (value) => {
                                    const date = new Date(value);
                                    return !isNaN(date) ? true : '유효한 날짜를 입력하세요.';
                                }
                            })}
                        >
                            {(inputProps) => (
                                <div className="htInputField">
                                    <label className="htBold">입차일시</label>
                                    <input
                                        {...inputProps}
                                        className={`htInput mt-7 mn-input ${errors.inDate ? 'has-error' : ''}`}
                                        placeholder="2024-11-20 13:15"
                                    />
                                    {errors.inDate && <span className="htError">{errors.inDate?.message}</span>}
                                </div>
                            )}
                        </InputMask> */}
                                    {/* New select inputs for extra hour and and minutes */}
                                    <div className="nl-row mb-20">
                                        <div className="col-6 mr-5 nh-relative">
                                            <label className="htBold">입차일시</label>
                                            <select
                                                className="mt-7 table-select"
                                                {...register('inHour')}
                                                value={watchInHour}
                                            >
                                                {generateHours.map(hour => (
                                                    <option key={hour} value={hour}>{hour}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-6 ml-5 nh-relative">
                                            <label className="htBold opacity-0 op">추가 시간</label>
                                            <select
                                                className="mt-7 table-select"
                                                {...register('inMinute')}
                                                value={watchInMinute}
                                            >
                                                {generateMinutes.map(minute => (
                                                    <option key={minute} value={minute}>{minute}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <label className="htCheckboxContainer">
                                        <AppCheckBox onChange={onCheckbox} />
                                        <span className="htCheckboxText">주차장 운영 시작시간으로 입차</span>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </AppInfiniteScroll>
                    <ButtonBot textYes="입차하기" typeYes="submit" />
                </form>
            }
            {showPopupError && (
                <Popup
                    title="알림"
                    handleYes={() => setShowPopupError(false)}
                    textYes="닫기"
                    setVisible={setShowPopupError}
                >
                    <div className="nl-row f-column">
                        <div>오류가 발생했습니다. 다시 시도해 주세요.</div>
                    </div>


                </Popup>
            )}
            {showPopupNoImage && (
                <Popup
                    title="알림"
                    handleYes={() => setShowPopupNoImage(false)}
                    textYes="닫기"
                    setVisible={setShowPopupNoImage}
                >
                    <div className="nl-row f-column">
                        <div>차량사진을 찍어주세요.</div>
                    </div>


                </Popup>
            )}
            {isPopupOpen && (
                <ImageViewPopup
                    imageSrc={image ?? carIamge}
                    onClose={() => {
                        setIsPopupOpen(false);
                        setZoomLevel(1);
                    }}
                    zoomLevel={zoomLevel}
                    setZoomLevel={setZoomLevel}
                />
            )}

            {showPopupParkingOperateTime && (
                <Popup
                    title="결제"
                    handleYes={() => setShowPopupParkingOperateTime(false)}
                    textYes="예"
                    setVisible={setShowPopupParkingOperateTime}
                >
                    <div className="nl-row f-column">
                        <div>주차장 운영 시간이 변경되었습니다. 다시 시도해 주세요.</div>
                    </div>


                </Popup>
            )}
        </>
    );
};

export default ParkingCheck;

function ParkingCheckSkeleton() {

    return (
        <div style={{ padding: '20px' }}>
            <Skeleton height={40} width="100%" style={{ marginBottom: '20px' }} />

            <div style={{ marginBottom: '10px' }}>
                <Skeleton height={185} width="100%" />
            </div>

            <div className="htSection">
                <div className="nl-row j-between"><Skeleton width={100} height={0} /> <Skeleton width={100} height={40} /></div>
            </div>
            <Skeleton height={40} width="100%" style={{ marginTop: '20px' }} />
            <Skeleton height={40} width="100%" style={{ marginTop: '20px' }} />
            <Skeleton height={40} width="100%" style={{ marginTop: '20px' }} />
        </div>
    );
}
